import React from 'react'
import Header from '../Components/Header/Header'
import Banner from '../Components/Banner/Banner'

import Products from '../Components/Products/Products'
import Footer from '../Components/Footer/Footer'
function Home() {
  return (
    <div>
      <Header></Header>
      
      <Products></Products>
      <Footer></Footer>
  
    </div>
  )
}

export default Home